import { useEffect, useState, useRef } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ChatCircleDots, PaperPlaneRight } from "@phosphor-icons/react";

export default function Messages() {
  const { user } = useAuth();
  const [convos, setConvos] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);

  const loadConvos = () => api.get("/messages/conversations").then(({ data }) => setConvos(data));
  useEffect(() => { loadConvos(); const t = setInterval(loadConvos, 5000); return () => clearInterval(t); }, []);

  useEffect(() => {
    if (!active) return;
    const load = () => api.get(`/messages/${active.convo_key}`).then(({ data }) => setMsgs(data));
    load();
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [active]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    if (!text.trim() || !active) return;
    await api.post("/messages", { property_id: active.property_id, receiver_id: active.other_id, text });
    setText("");
    const { data } = await api.get(`/messages/${active.convo_key}`);
    setMsgs(data);
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8">
        <h1 className="font-display text-3xl font-bold text-stone-900 mb-5">Messagerie</h1>
        <div className="grid md:grid-cols-3 gap-4 bg-white border border-stone-200 rounded-2xl overflow-hidden" style={{ minHeight: "60vh" }}>
          {/* list */}
          <div className="border-r border-stone-200 divide-y divide-stone-100 max-h-[70vh] overflow-y-auto">
            {convos.length === 0 && <div className="p-6 text-center text-stone-400 text-sm">Aucune conversation.</div>}
            {convos.map((c) => (
              <button key={c.convo_key} data-testid={`convo-${c.convo_key}`} onClick={() => setActive(c)}
                className={`w-full text-left p-4 hover:bg-stone-50 transition-colors ${active?.convo_key === c.convo_key ? "bg-orange-50" : ""}`}>
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-stone-900 text-sm truncate">{c.property_title}</span>
                  {c.unread > 0 && <span className="bg-orange-800 text-white text-[10px] rounded-full px-1.5">{c.unread}</span>}
                </div>
                <div className="text-xs text-stone-500 truncate mt-0.5">{c.last_message}</div>
              </button>
            ))}
          </div>
          {/* thread */}
          <div className="md:col-span-2 flex flex-col">
            {!active ? (
              <div className="flex-1 grid place-items-center text-stone-400">
                <div className="text-center"><ChatCircleDots size={40} className="mx-auto opacity-40 mb-2" />Sélectionnez une conversation</div>
              </div>
            ) : (
              <>
                <div className="p-4 border-b border-stone-200 font-display font-bold text-stone-900">{active.property_title}</div>
                <div className="flex-1 p-4 space-y-3 overflow-y-auto max-h-[55vh]">
                  {msgs.map((m) => (
                    <div key={m.id} className={`flex ${m.sender_id === user.user_id ? "justify-end" : "justify-start"}`}>
                      <div className={`max-w-[75%] rounded-2xl px-4 py-2 text-sm ${m.sender_id === user.user_id ? "bg-orange-800 text-white" : "bg-stone-100 text-stone-800"}`}>
                        {m.text}
                      </div>
                    </div>
                  ))}
                  <div ref={endRef} />
                </div>
                <div className="p-3 border-t border-stone-200 flex gap-2">
                  <Input data-testid="message-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Votre message…" />
                  <Button data-testid="message-send" onClick={send} className="rounded-full bg-orange-800 hover:bg-orange-900 text-white px-4"><PaperPlaneRight weight="fill" /></Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
